import { Button } from '@/components/ui/button'
import PaymentMethodDialogAdd from './payment-method-dialog-add'
import { useState } from 'react'
import PaymentMethodItem from './payment-method-item'
import { useUser } from '@/pages/enterprise/user-provider'
import { useIsFetching } from '@tanstack/react-query'
import { getOrganizationInfoOrganizationInfoGetQueryKey } from '@/generated/@tanstack/react-query.gen'
import spinner from '@/assets/svg/spinner.svg'
import { PaymentMethodPlaidLinkComponent } from './payment-method-plaid-link'
import Spinner from '@/components/Spinner'
import { getPlaidLinkTokenGetPlaidLinkTokenGetQueryKey } from '../../../../../generated/@tanstack/react-query.gen'

export default function PaymentMethod() {
  const limitCard = 4
  const [openAddDialog, setOpenAddDialog] = useState(false)
  const isFetching = useIsFetching({
    queryKey: getOrganizationInfoOrganizationInfoGetQueryKey(),
  })

  const isFetchingPlaidLink = useIsFetching({
    queryKey: getPlaidLinkTokenGetPlaidLinkTokenGetQueryKey(),
  })

  const { paymentMethods } = useUser()

  return (
    <>
      <div className="mx-auto w-full gap-4 flex flex-col">
        <div className="flex  flex-col md:flex-row gap-4 justify-between">
          <h2 className="text-2xl font-bold whitespace-nowrap">
            Payment Methods
          </h2>
          {paymentMethods.length < limitCard && (
            <Button
              onClick={() => setOpenAddDialog(true)}
              variant="window"
              size="sm"
            >
              Add a Payment Method
            </Button>
          )}
        </div>
      </div>
      {isFetching ? (
        <div className="flex justify-center items-center">
          <img src={spinner} alt="Loading..." className="h-24" />
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 text-sm">
          {paymentMethods &&
            paymentMethods.map((method) => (
              <PaymentMethodItem
                key={method.payment_method_id}
                paymentMethod={method}
              />
            ))}
        </div>
      )}
      <PaymentMethodDialogAdd
        open={openAddDialog}
        onOpenChange={() => setOpenAddDialog(false)}
      />
      <PaymentMethodPlaidLinkComponent />

      {isFetchingPlaidLink ? <Spinner /> : <></>}
    </>
  )
}
